@if (date) {
	<span
		title="{{ date | temporalZonedMap: tz | temporalIntlFormat: numericUs }}"
	>
		{{ date | temporalZonedMap: tz | temporalIntlFormat: computedDateFormat }}
	</span>
} @else {
	<span> - </span>
}
